import React from 'react';
import PropTypes from 'prop-types';
import { PlayFill } from 'grommet-icons';
import classnames from 'classnames';
import useResponsive from '../../hooks/useResponsive';

const Play = ({ handleClick, itemTitle }) => {
  const { isTablet } = useResponsive();

  return (
    <button
      data-play-podcast-name={itemTitle}
      type="button"
      className={classnames('play_button lg_player_button', {
        m_player_button: isTablet,
      })}
      onClick={() => handleClick()}
      title="Play"
    >
      <PlayFill
        style={{
          width: '18px',
          height: '18px',
          margin: '0',
          pointerEvents: 'none',
        }}
        color={isTablet ? 'rgb(40, 47, 54)' : 'white'}
      />
    </button>
  );
};

Play.propTypes = {
  handleClick: PropTypes.func.isRequired,
  itemTitle: PropTypes.string.isRequired,
};
export default Play;
